export default __webpack_public_path__ + "static/media/aerospike.690f4c20.svg";